<template lang="pug">
  #challenge-builder-define
    WtTitle(h2) Step 2: Define Your Challenge

    ChallengeBuilderDefineForm(@validationResult="handleValidationResult($event)")

    ChallengeBuilderControls(:step-to-activate="3" :allow-next="enableNextStep")
</template>

<script>
import WtTile from "@@/WtTile/WtTile";
import WtTitle from "@@/WtTitle/WtTitle";
import ChallengeBuilderControls from "@@/ChallengeBuilder/ChallengeBuilderControls";
import ChallengeBuilderDefineForm from "@@/ChallengeBuilder/ChallengeBuilderDefineForm";

/**
 * Challenge Builder wrapper for Step 2, details about the challenge
 */
export default {
  name: "ChallengeBuilderDefine",

  components: {
    ChallengeBuilderDefineForm,
    ChallengeBuilderControls,
    WtTile,
    WtTitle
  },

  data() {
    return {
      enableNextStep: false,
      validateForm: false
    };
  },

  mounted() {
    this.enableNextStep = false;
  },

  methods: {
    updateAndValidateChallengeFields() {
      this.validateForm = true;
    },

    handleValidationResult(result) {
      this.enableNextStep = result;
    }
  }
};
</script>

<style lang="sass" scoped>
#challenge-builder-define
  .define-radio
    margin-right: 1.5rem
</style>
